(function() {
  var config = document.getElementById('LanguagePreference');
  if (!config || config.dataset.designMode === 'true') return;

  var key = 'dariofits.language';
  var guardKey = key + '.redirect';
  var current = config.dataset.language;
  var available = Array.from(config.querySelectorAll('option')).map(function(option) {
    return option.value;
  });

  function remember(language) {
    if (available.indexOf(language) === -1) return;
    try {
      localStorage.setItem(key, language);
      sessionStorage.removeItem(guardKey);
    } catch (error) {}
  }

  function returnTo(language) {
    var option = Array.from(config.querySelectorAll('option')).find(function(item) {
      return item.value === language;
    });
    var currentRoot = config.dataset.root.replace(/\/$/, '');
    var targetRoot = option ? option.dataset.root.replace(/\/$/, '') : currentRoot;
    var path = window.location.pathname;
    if (currentRoot && (path === currentRoot || path.indexOf(currentRoot + '/') === 0)) {
      path = path.slice(currentRoot.length);
    }
    return (targetRoot + (path || '/')) + window.location.search + window.location.hash;
  }

  window.themeLanguage = { remember: remember, returnTo: returnTo };

  var saved;
  try {
    saved = localStorage.getItem(key);
  } catch (error) {
    return;
  }

  if (config.dataset.primary !== 'true' || !saved || available.indexOf(saved) === -1 || saved === current) {
    remember(current);
    return;
  }

  if (/^\/(checkouts?|account|challenge|apps)(\/|$)/.test(window.location.pathname)) return;

  try {
    var previous = JSON.parse(sessionStorage.getItem(guardKey) || 'null');
    if (previous && previous.language === saved && Date.now() - previous.time < 30000) return;
    sessionStorage.setItem(guardKey, JSON.stringify({ language: saved, time: Date.now() }));
  } catch (error) {
    return;
  }

  var form = document.getElementById('LanguagePreferenceForm');
  form.elements.language_code.value = saved;
  form.elements.return_to.value = returnTo(saved);
  form.submit();
})();
